"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateButtonWidget = exports.addButtonWidget = void 0;
var slate_1 = require("slate");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var slate_react_1 = require("slate-react");
var lodash_1 = require("lodash");
var addButtonWidget = function (editor) {
    var buttonProps = TokenModels_1.default.button.createSlateJson();
    var overrideProps = { data: { autoFocus: true } };
    var props = (0, lodash_1.merge)(buttonProps, overrideProps);
    slate_1.Transforms.setNodes(editor, props);
    slate_react_1.ReactEditor.blur(editor);
};
exports.addButtonWidget = addButtonWidget;
var updateButtonWidget = function (editor, path, updatedData) {
    var buttonBlockEntry = slate_1.Editor.node(editor, path);
    var existingData = buttonBlockEntry[0].data;
    var data = __assign(__assign({}, existingData), updatedData);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
};
exports.updateButtonWidget = updateButtonWidget;
